var map = {
	".": "FZvV",
	"./": "FZvV",
	"./01_trade_info": "tk7z",
	"./01_trade_info.json": "tk7z",
	"./02_kline_data": "klxE",
	"./02_kline_data.json": "klxE",
	"./03_depth_info": "ADmP",
	"./03_depth_info.json": "ADmP",
	"./04_24hr_ticker": "7Biw",
	"./04_24hr_ticker.json": "7Biw",
	"./05_last_price": "q1yk",
	"./05_last_price.json": "q1yk",
	"./06_book_ticker": "vVRe",
	"./06_book_ticker.json": "vVRe",
	"./07_depth_incr_info": "MY8u",
	"./07_depth_incr_info.json": "MY8u",
	"./index": "FZvV",
	"./index.js": "FZvV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "JfGl";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/spot/websocket/market ^.*$
// module id = JfGl
// module chunks = 3